<template>
  <p style="text-align: center;letter-spacing: 1px;color: #999;font-size: 13px;height: 60px; line-height: 30px">
    <span style="font-size: 15px">销售送货单管理模块V1.0</span><br/>
    <span>Copyright © 2025 青岛升平电气有限公司</span>
  </p>
</template>

